import type { ValueOf } from 'type-fest';

import type { Message } from '@sats-group/fresh-fitness-ui-lib/react/message/message.types';

import type { Logo } from 'root/client/components/logo/logo.types';
import type { Progress } from 'root/client/components/progress/progress.types';

export const themes = {
  confirmation: 'confirmation',
} as const;

export type SalesLayout = {
  dynamicMessages: Message[];
  isLoading?: boolean;
  logo: Logo;
  messages: Message[];
  progress?: Progress;
  theme?: ValueOf<typeof themes>;
  title?: string;
};
